import { ApiAction } from "../api/actions/ApiAction";
import {
  getAutocompleteAirports,
  GetAutocompleteAirportsResponse,
} from "../api/actions/getAutocompleteAirports";

export function getAirportNamesRecord(request: <R>(action: ApiAction) => Promise<R>) {
  return async function (codes: string[]): Promise<Record<string, string>> {
    try {
      const autocompleteAirports = await Promise.all(
        codes.map((code) =>
          request<GetAutocompleteAirportsResponse>(getAutocompleteAirports({ query: code }))
        )
      );
      return autocompleteAirports
        .map(([airport]) => airport)
        .filter(Boolean)
        .reduce(
          (acc, airport) => ({ ...acc, ...(airport ? { [airport.code]: airport.name } : {}) }),
          {}
        );
    } catch (error) {
      return {};
    }
  };
}
